<template>
  <div>
    <tci-about-us :title="$t('overview.title')">
      <v-row class="pb-2">
        <v-spacer class="d-none d-sm-flex"></v-spacer>
        <v-col>
          <v-card class="mt-0" :width='isMobile?"":700' flat tile color="transparent">
            <v-card-title class="body-1" v-html="$t('overview.content')"></v-card-title>
          </v-card>
        </v-col>
        <v-spacer class="d-none d-sm-flex"></v-spacer>
      </v-row>
      <v-row v-for="item in $t('overview.companys')" :key="item.companyName">
        <v-spacer class="d-none d-sm-flex"></v-spacer>
        <v-col>
          <v-divider class="py-1" color="#E1EBF5"></v-divider>
          <v-list :width='isMobile?"":600'>
            <v-list-item>
              <v-list-item-title>{{ item.companyName }}</v-list-item-title>
            </v-list-item>
            <div v-for="itemInfo in item.infos" :key="itemInfo.key">
              <v-divider></v-divider>
              <v-list-item>
                <v-row>
                  <v-col cols="4" sm="3">
                    <v-list-item-title>{{ itemInfo.key }}</v-list-item-title>
                  </v-col>
                  <v-col cols="8" sm="9">
                    <v-list-item-subtitle class="text-wrap">{{ itemInfo.value }}</v-list-item-subtitle>
                  </v-col>
                </v-row>
              </v-list-item>
            </div>
          </v-list>
        </v-col>
        <v-spacer class="d-none d-sm-flex"></v-spacer>
      </v-row>
      <v-divider></v-divider>
    </tci-about-us>
    <tci-contact-footer color="white"></tci-contact-footer>
  </div>
</template>

<script>
import TciAboutUs from "@/components/TciAboutUs.vue";
import TciContactFooter from "@/components/TciContactFooter.vue";

export default {
  name: "CompanyOverview",
  data: () => ({
    isMobile: false
  }),
  components: {
    "tci-about-us": TciAboutUs,
    "tci-contact-footer": TciContactFooter
  },
  mounted() {
    this.isMobile = this.$vuetify.breakpoint.xs;
  }
};
</script>
